import React from "react";
import PropTypes from "prop-types";
import Translation from "../../../../localization/Translation";
import PaymentImage from "./PaymentImage";
import transactionsList from "../../../../../resources/images/icon-transactions-list.svg";
import BuyOrderFinishedInfo from "./BuyOrderFinishedInfo";
import PaymentInstruction from "./PaymentInstruction";
import PaymentInstructionList from "./PaymentInstructionList";
import FormattedAmount from "../../../../components/formatted.amount/FormattedAmount";
import { defaultDecimalPlaces } from "../../../../constants";

const BuyOrderStep2 = ({
  orderNumber,
  amount,
  activeFiat,
  paymentMethodConfig,
  isSepa,
  isBankgiro
}) => {
  return (
    <BuyOrderFinishedInfo
      step={2}
      title={<Translation>{paymentMethodConfig.instructions.step2}</Translation>}
    >
      {isSepa && (
        <>
          <PaymentInstructionList config={paymentMethodConfig.paymentInfo} type={"single"} />
          <PaymentImage src={transactionsList} alt="order transactions list" />
        </>
      )}
      {isBankgiro && (
        <>
          <PaymentInstruction label={paymentMethodConfig.label} toCopy={paymentMethodConfig.number}>
            {paymentMethodConfig.number}
          </PaymentInstruction>
          <PaymentInstruction label={paymentMethodConfig.orc.label} toCopy={orderNumber}>
            {orderNumber}
          </PaymentInstruction>
          <PaymentInstruction
            label={paymentMethodConfig.amount.label}
            additionalLabel={paymentMethodConfig.amount.additionalLabel}
            toCopy={`${amount.toFixed(defaultDecimalPlaces.fiat)} ${activeFiat}`}
          >
            <FormattedAmount currency={activeFiat}>{amount}</FormattedAmount>
          </PaymentInstruction>
        </>
      )}
    </BuyOrderFinishedInfo>
  );
};

BuyOrderStep2.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  orderNumber: PropTypes.string.isRequired,
  paymentMethodConfig: PropTypes.object.isRequired,
  activeFiat: PropTypes.string.isRequired
};

export { BuyOrderStep2 };
